module.exports = __webpack_public_path__ + "img/AdobeStock.9e3401c8.png";